import React from 'react';
import './Process.css';

const Process = () => {
  return (
    <div className="process-container">
      <div className="process-hero">
        <h1 className="process-title">How We Work</h1>
        <p className="process-subtitle">
          From first contact to product launch, we follow a streamlined, transparent process to bring your ideas to life.
        </p>
      </div>

      <div className="process-steps">
        <div className="step">
          <div className="step-number">1</div>
          <h3>Submit Your Idea</h3>
          <p>Tell us what you're building. Use our AI-powered quote generator to get a project draft instantly.</p>
        </div>

        <div className="step">
          <div className="step-number">2</div>
          <h3>Review & Edit Quotation</h3>
          <p>You can tweak the features, scope, or priorities — and once done, hit submit to get our team in touch.</p>
        </div>

        <div className="step">
          <div className="step-number">3</div>
          <h3>Project Kickoff</h3>
          <p>We assign a lead, set up your dashboard, and start development with regular updates and iterations.</p>
        </div>

        <div className="step">
          <div className="step-number">4</div>
          <h3>Launch & Support</h3>
          <p>Your product goes live — and we stay by your side for testing, bug fixing, and scaling when needed.</p>
        </div>
      </div>

      <div className="quote-cta">
        <h2>Ready to Start?</h2>
        <p>Generate your AI-powered project quotation now and let’s build something great together.</p>
        <button onClick={() => window.open('/project_prompt', '_blank')}>
          Generate Quotation
        </button>
      </div>
    </div>
  );
};

export default Process;
